/**
 * axios 응답 인터셉터를 등록해 API 에러를 전역에서 가로채는 함수.
 *
 * `pages/_app.tsx`에서 앱 시작 시 한 번만 호출된다. 특정 상태 코드를 따로 분기하지 않고
 * 모든 에러 응답을 동일하게 처리한다.
 *
 * 주의: `TOAST_BLACKLIST`가 빈 문자열(`['']`) 하나만 담고 있는데, 모든 URL 문자열은
 * 빈 문자열을 포함하므로 `LOGIN_TOAST_FLAG`가 항상 true로 계산된다. 그 결과 "에러 토스트 표시"
 * 분기는 현재 실행되지 않고(코드도 비어 있다), 항상 "IGNORE" 분기만 탄다.
 */
import { APIClient } from '../api/client';

const TOAST_BLACKLIST = [''];

export const handleAPIError = () => {
  APIClient.client.interceptors.response.use(
    (res) => res,
    (err) => {
      const LOGIN_TOAST_FLAG = TOAST_BLACKLIST.map((i) =>
        err.config.url.includes(i),
      ).includes(true);

      if (LOGIN_TOAST_FLAG) {
        //! IGNORE THIS FLAG
      } else {
        // SHOW ERROR TOAST
      }

      return Promise.reject(err);
    },
  );
};
